import ITipoCaminhao from '../entities/TipoCaminhao'
import { ITipoCaminhaoRepository } from '../repositories/ITipoCaminhaoRepository'

export interface IFindAll {
  execute(): Promise<ITipoCaminhao[]>
}

export default class FindAllImpl implements IFindAll {
  constructor(
    private readonly tipoCaminhaoRepository: ITipoCaminhaoRepository,
  ) {}

  public async execute(): Promise<ITipoCaminhao[]> {
    const response = await this.tipoCaminhaoRepository.findAll()
    return response
  }
}
